var map = {
	"./10_clovers.svg": "Ip1o",
	"./10_hearts.svg": "PjdW",
	"./10_pikes.svg": "Qovh",
	"./10_tiles.svg": "6lEI",
	"./10_tilesi.svg": "vz0b",
	"./2_clovers.svg": "I0J8",
	"./2_hearts.svg": "b/Fa",
	"./2_pikes.svg": "fODG",
	"./2_tiles.svg": "5s96",
	"./3_clovers.svg": "7xVX",
	"./3_hearts.svg": "A6Df",
	"./3_pikes.svg": "nX0L",
	"./3_tiles.svg": "FbFi",
	"./4_clovers.svg": "xnoe",
	"./4_hearts.svg": "MydI",
	"./4_pikes.svg": "Dq3Q",
	"./4_tiles.svg": "d0Pe",
	"./5_clovers.svg": "WLBB",
	"./5_hearts.svg": "asoy",
	"./5_pikes.svg": "0zNK",
	"./5_tiles.svg": "ntcw",
	"./6_clovers.svg": "jdIr",
	"./6_hearts.svg": "Rjm3",
	"./6_pikes.svg": "aMR8",
	"./6_tiles.svg": "0pii",
	"./7_clovers.svg": "L90M",
	"./7_hearts.svg": "ynMW",
	"./7_pikes.svg": "pFtP",
	"./7_tiles.svg": "rNb3",
	"./8_clovers.svg": "CPd8",
	"./8_hearts.svg": "ZYLt",
	"./8_pikes.svg": "OZdl",
	"./8_tiles.svg": "IPYo",
	"./9_clovers.svg": "Wd85",
	"./9_hearts.svg": "MgAG",
	"./9_pikes.svg": "klRf",
	"./9_tiles.svg": "ABGH",
	"./A_clovers.svg": "h+0+",
	"./A_hearts.svg": "LXQg",
	"./A_pikes.svg": "1IvC",
	"./A_tiles.svg": "QR85",
	"./J_clovers.svg": "tjrr",
	"./J_hearts.svg": "jLL3",
	"./J_pikes.svg": "dRGx",
	"./J_tiles.svg": "HIFB",
	"./K_clovers.svg": "qo/b",
	"./K_hearts.svg": "Z07K",
	"./K_pikes.svg": "WFfz",
	"./K_tiles.svg": "NHq5",
	"./Q_clovers.svg": "bTw5",
	"./Q_hearts.svg": "Ps/C",
	"./Q_pikes.svg": "uVyc",
	"./Q_tiles.svg": "xpqs",
	"./dealer-coperto.svg": "eTcp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wA8c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards ^\.\/.*\.svg$
// module id = wA8c
// module chunks = 1